<template>
  <div>
    <div>
      <b-modal id="reservation-modal" v-model="modalShow" centered hide-header hide-footer>
        <div class="d-block text-center modal-container">
          <div class="content-header">{{ $t('preOrder.preOrder') }}</div>
          <div class="content-desc">
            <p class="content-desc-body">{{ $t('preOrder.preOrderhowToUseDescription') }}</p>
            <p class="content-desc-body">{{ $t('preOrder.soldOutDescription') }}</p>
          </div>
          <div>
            <b-row class="buttons">
              <b-col>
                <div>
                  <so-close-button @click="handleClose">{{ $t('common.close') }}</so-close-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  name: 'PreOrderWarningModal',
  components: {
    SoCloseButton,
  },
  computed: {
    ...mapGetters({
      isShowingPreOrderWarningModal: 'modal/isShowingPreOrderWarningModal',
    }),
    modalShow: {
      get() {
        return this.isShowingPreOrderWarningModal
      },
      set(value) {
        this.setShowingPreOrderWarningModal(value)
      },
    },
  },
  methods: {
    ...mapActions({
      setShowingPreOrderWarningModal: 'modal/setShowingPreOrderWarningModal',
    }),
    handleClose() {
      this.setShowingPreOrderWarningModal(false)
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;

  &-header {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 16px;
  }

  &-desc {
    padding: 16px 0 0;
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.content-desc-body {
  white-space: pre-wrap;
}
.buttons {
  margin-top: 20px;
}
</style>
